import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "../store/useAuthStore";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { user, loading } = useAuthStore();
  const location = useLocation();

  // If we have a user, redirect to intended destination (if any), else home
  if (user) {
    const from = location.state as
      | { from?: { pathname?: string; search?: string } }
      | undefined;
    const redirectQuery = new URLSearchParams(location.search).get("redirect");

    const target = from?.from?.pathname
      ? `${from.from.pathname}${from.from.search || ""}`
      : redirectQuery || "/";

    return <Navigate to={target} replace />;
  }

  // If we're still loading, show spinner
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Show the content (login/register) if we're not loading and not logged in
  return <>{children}</>;
};

export default PublicRoute;
